import React from 'react'
import { Button } from '../../../components/ui/button'
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from '../../../components/ui/dialog';
import { Input } from '@headlessui/react';
import { PhoneNumberUtil } from 'google-libphonenumber';
import PhoneInput, { CountryData } from 'react-phone-input-2';
import { z } from 'zod';
import { Controller, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';

const formSchema = z.object({
  phoneNumber: z.string().min(1, 'Phone number is required').max(15, 'Phone number must be at most 15 digits long')
});

type FormSchema = z.infer<typeof formSchema>;

const UpdatePhoneNumber: React.FC = () => {
  const form = useForm({
    resolver: zodResolver(formSchema),
    defaultValues: {
      phoneNumber: '60'
    }
  });

  const { register, setValue, watch } = form;

  const onSubmit = (data: FormSchema) => {
    const phoneUtil = PhoneNumberUtil.getInstance();
    try {
      const number = phoneUtil.parseAndKeepRawInput(data.phoneNumber, 'MY');
      const formattedNumber = phoneUtil.isValidNumber(number, );
      console.log('Formatted Phone Number:', formattedNumber);
    } catch (error) {
      console.error('Error parsing phone number:', error);
    }
  }

  return (
    <div className="flex items-center justify-between gap-2 border-t-1 py-4">
      <div className="flex flex-col gap-1">
        <h3 className="text-sm font-medium text-gray-900 flex items-center gap-2">
          Update Phone Number
        </h3>
        <p className="text-sm text-gray-500">
          Phone number changed? Update it now
        </p>
        <p className="text-sm italic text-gray-500">
          Phone number last updated: July 13, 2024
        </p>
      </div>
      
      <Dialog>
        <DialogTrigger asChild>
          <Button
            type="button"
            className="min-w-24 disabled:bg-gray-700"
          >
            Update
          </Button>
        </DialogTrigger>
        <DialogContent className="max-w-[24rem] rounded-3xl">
          <DialogHeader>
            <DialogTitle>Enter Old Phone Number</DialogTitle>
          </DialogHeader>

          <div className="flex flex-col gap-4">
            <form onSubmit={form.handleSubmit(onSubmit)} className="flex flex-col gap-4">
              <Controller
                name="phoneNumber"
                control={form.control}
                render={({ field }) => (
                  <PhoneInput
                    country={'my'}
                    value={field.value}
                    onChange={(value: string) => {
                      field.onChange(value);
                      setValue('phoneNumber', value);
                    }}
                    inputStyle={{ width: '100%' }}
                    enableSearch={false}
                    disableCountryCode={true}
                    countryCodeEditable={true} // Allow users to edit the country code
                    placeholder="Enter your phone number"
                    autoFormat={false}
                  />
                )}
              />
              <Button type="submit" className='bg-[#5CB891]'>Continue</Button>
            </form>

          </div>
        </DialogContent>
      </Dialog>
    </div>
  )
}

export default UpdatePhoneNumber;